import React, { Component } from 'react';
class EirCustomiseTvChannels extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            title: "Channel Compare",
            description: "Channel compare description here",
            channelList: [],
            toggleView: false
        };
    }
    render() {
        return (
            <div className="d-none"></div>
        )
    }
}

export default EirCustomiseTvChannels;